import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchRecentTrips, type RecentTrip } from '../api/trip';

type UseRecentTripsResult = {
  trips: RecentTrip[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
};

export const useRecentTrips = (currentTripId: string): UseRecentTripsResult => {
  const [trips, setTrips] = useState<RecentTrip[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const prevTripIdRef = useRef(currentTripId);

  const refetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchRecentTrips();
      setTrips(data);
    } catch {
      setError('履歴の取得に失敗しました');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    if (prevTripIdRef.current !== currentTripId && currentTripId !== 'new') {
      refetch();
      prevTripIdRef.current = currentTripId;
    }
  }, [currentTripId, refetch]);

  return { trips, loading, error, refetch };
};
